import { useTranslation } from 'react-i18next';

import { useAuth } from '@/contexts/AuthContext';
import { useFeatureVisibility } from '@/contexts/FeatureVisibilityContext';

import {
  useUsageMonitoringFilters,
  useUsageOrganizationsQuery,
} from '../hooks/useUsageMonitoring';

export function UsageOrganizationSelector() {
  const { t } = useTranslation();
  const { user } = useAuth();
  const { isActionEnabled } = useFeatureVisibility();
  const { filters, setOrganizationId } = useUsageMonitoringFilters();

  const flagOn = isActionEnabled('usage_monitoring.cross_organization', false);
  // is_superuser llega en el login nuevo; si la sesión es antigua (undefined), se prueba el API.
  const enabled =
    flagOn && user?.is_superuser !== false && (user?.is_superuser === true || user?.is_superuser == null);

  const orgsQuery = useUsageOrganizationsQuery(enabled);

  if (!enabled) return null;
  if (orgsQuery.isError || !orgsQuery.data?.results?.length) return null;

  const ownOrgId = user?.organization?.id;
  const selected =
    filters.organizationId != null
      ? String(filters.organizationId)
      : ownOrgId != null
        ? String(ownOrgId)
        : '';

  return (
    <label className="flex flex-col gap-1 text-xs font-medium text-gray-600">
      {t('adoption.filters.organization')}
      <select
        value={selected}
        onChange={(e) => {
          const next = Number(e.target.value);
          if (!Number.isFinite(next)) {
            setOrganizationId(null);
            return;
          }
          if (ownOrgId != null && next === ownOrgId) {
            setOrganizationId(null);
            return;
          }
          setOrganizationId(next);
        }}
        className="min-w-[12rem] rounded-md border border-gray-300 px-2.5 py-1.5 text-sm text-gray-900 shadow-sm focus:border-stocker-primary focus:outline-none focus:ring-1 focus:ring-stocker-primary"
        disabled={orgsQuery.isLoading}
      >
        {(orgsQuery.data?.results ?? []).map((org) => (
          <option key={org.id} value={org.id}>
            {org.code ? `${org.code} — ${org.name}` : org.name}
          </option>
        ))}
      </select>
    </label>
  );
}
